if (window.innerWidth >= 500) {
    // document.body.classList.add('');

    const sectionSlides = document.querySelectorAll('section.slide:not(.benten)');

    for (let i = 0; i < sectionSlides.length; i++) {
        // sectionSlides[i].style.paddingTop = parseInt(getComputedStyle(sectionSlides[i]).paddingTop) + 60 + 'px';
        // sectionSlides[i].style.top = '30px';
    }
}

$(".product__next").click(function () {
    nextSlide()
})

function openSmeta(smetaN) {
    if (!$('.options-' + smetaN).is(':hidden')) {
        $('.options').slideUp();
        $('.smeta-item-head').removeClass('active');
        $('.smeta-item').removeClass('active');
        $('.smeta-' + smetaN).find('.smeta-opener').text('Открыть пункт');
    } else {
        $('.smeta-item-head').removeClass('active');
        $('.smeta-item').removeClass('active');
        $('.smeta-' + smetaN).addClass('active');
        $('.options').slideUp();
        $('.options-' + smetaN).slideDown();
        $('.options-' + smetaN).parents(".smeta-item").addClass('active');
        $('.smeta-' + smetaN).find('.smeta-opener').text('Закрыть пункт');
    }
}

var timeStart = 0;

function wheely(e) {
    var y = e.originalEvent.deltaY;
    var timeStop = new Date().getTime();
    var timeDiff = timeStop - timeStart;
    if (timeDiff > 200) {
        if (y > 0) {
            nextSlide();
        }
        if (y < 0) {
            prevSlide();
        }
    }
    timeStart = timeStop;

    let video = document.querySelector(".we-build__video video")
    if(video){
        if($(".we-build").hasClass("parallax-active")){
            video.addEventListener('click',function(){
                video.play();
            },false);
            video.click();
        }else{
            video.pause()
        }
    }

    let video2 = document.querySelector(".recommendation__video video")
    if(video2){
        if($(".home-calc").hasClass("parallax-active")){
            video2.addEventListener('click',function(){
                video2.play();
            },false);
            video2.click();
        }else{
            video2.pause()
        }
    }


    // if (document.querySelector('.second_screen').classList.contains('parallax-active')) {
    // document.querySelector('#video_what_build').play();
    // } else {
    // document.querySelector('#video_what_build').pause();
    // }

    // if (document.querySelector('.completeset').classList.contains('parallax-active')) {
    // document.querySelector('.completeset__info-image').play();
    // } else {
    // document.querySelector('.completeset__info-image').pause();
    // }
}

function prevSlide() {
    if ($(".parallax-active").is(":first-child")) {
        if (!$(".parallax-slider").hasClass("dragging")) {
            $(".slide:first-child").addClass("bounce");
            setTimeout(function() {
                $(".slide:first-child").removeClass("bounce");
            }, 300);
        }
    } else {
        $(".parallax-active")
            .removeClass("parallax-active")
            .addClass("queue")
            .prev()
            .removeClass("prev")
            .addClass("parallax-active");
    }

    setActiveTab()

    // if (document.querySelector(".section_first_screen.parallax-active")) {
    //     document.querySelector('header').classList.remove('active');
    // } else {
    //     document.querySelector('header').classList.add('active');
    // }
    //
    // if (document.querySelector('.completeset').classList.contains('parallax-active')) {
    //     document.querySelector('.completeset__info-image').play();
    // } else {
    //     document.querySelector('.completeset__info-image').pause();
    // }
}

function nextSlide() {
    if ($(".parallax-active").is(":last-child")) {
        if (!$(".parallax-slider").hasClass("dragging")) {
            $(".slide:last-child").addClass("bounce");
            setTimeout(function() {
                $(".slide:last-child").removeClass("bounce");
            }, 300);
        }
    } else {
        $(".parallax-active")
            .removeClass("parallax-active")
            .addClass("prev")
            .next()
            .removeClass("queue")
            .addClass("parallax-active");
    }

    if (document.querySelector(".section_first_screen.parallax-active")) {
        document.querySelector('header').classList.remove('active');
    } else {
        document.querySelector('header').classList.add('active');
    }

    setActiveTab()
}

function hotkeys(e) {
    if (e.keyCode == 38) {
        prevSlide();
    }

    if (e.keyCode == 40) {
        e.preventDefault();
        nextSlide();
    }
}

function dragStart(e) {
    e.preventDefault();
    if (e.type == "touchstart") {
        $(document).off("mousedown", dragStart);
        startPoint = e.originalEvent.touches[0].pageY;
    } else {
        startPoint = e.pageY;
    }
    dragDist = 0;
    $(document).on("touchmove mousemove", dragMove);
}

function dragMove(e) {
    if (e.type == "touchmove") {
        var movePoint = e.originalEvent.touches[0].pageY;
    } else {
        var movePoint = e.pageY;
    }
    dragDist = ((movePoint - startPoint) / $(".parallax-slider").height()) * 100;

    $(".parallax-slider").addClass("dragging");

    $(".slide, .bg").css({
        transition: "0ms",
    });

    if (window.innerWidth >= 500) {
        if (dragDist < 0) {
            $(".parallax-active .bg").css({
                opacity: 1 + dragDist / 200,
            });
            $(".active")
                .css({
                    transform: "translate3d(0," + dragDist / 2 + "%,0)",
                })
                .next()
                .css({
                    transform: "translate3d(0," + (100 + dragDist) + "%,0)",
                });
        }
    }

    if (window.innerWidth >= 500) {
        if (dragDist > 0) {
            $(".parallax-active")
                .css({
                    transform: "translate3d(0," + dragDist + "%,0)",
                })
                .prev()
                .css({
                    animation: "none",
                    transform: "translate3d(0," + (-50 + dragDist / 2) + "%,0)",
                })
                .find(".bg")
                .css({
                    opacity: 0.5 + dragDist / 200,
                });
        }
    }
}

function dragEnd() {
    $(document).off("touchmove mousemove", dragMove);
    $(".slide, .bg").removeAttr("style");
    if (dragDist > 20) {
        prevSlide();
    }
    if (dragDist < -20) {
        nextSlide();
    }

    setTimeout(function() {
        $(".parallax-slider").removeClass("dragging");
    }, 800);
}

$(document).on("wheel", wheely);
$(document).on("keydown", hotkeys);
$(document).on("touchstart", dragStart);
$(document).on("touchend", dragEnd);


$(document).on('click', '.smeta-item-head', function(e) {
    console.log('открытие сметы');
    console.log(e.target.tagName)
    if (e.target.tagName === 'INPUT') {} else {
        var smetaN = $(this).attr('data-smeta');

        openSmeta(smetaN);

        $(document).off("wheel", wheely);
        $(document).off("keydown", hotkeys);
        $(document).off("touchstart mousedown", dragStart);
        $(document).off("touchend", dragEnd);
        $('.estimate').css({
            overflowY: 'auto',
            // paddingTop: '60px'
        });

        $(".estimate").scroll(function() {
            var element = $(this);
            if ($(element).scrollTop() + $(element).innerHeight() >= element[0].scrollHeight) {
                $('.estimate').css({
                    overflowY: 'hidden',
                    top: '0px'
                });
                $('.open-table').text('Раскрыть смету');

                const sectionSlides = document.querySelectorAll('section.slide:not(.benten)');

                for (let i = 0; i < sectionSlides.length; i++) {
                    // sectionSlides[i].style.paddingTop = parseInt(getComputedStyle(sectionSlides[i]).paddingTop) + 60 + 'px';
                    sectionSlides[i].style.top = '60px';
                }

                $(document).on("wheel", wheely);
                $(document).on("keydown", hotkeys);
                $(document).on("touchstart mousedown", dragStart);
                $(document).on("touchend mouseup", dragEnd);

                $('.options').slideUp(500);
                $('.smeta-item-head').removeClass('active');
                opened = 1;

                console.log('its working');
            }
        });

    }

    return false;
});

function openSm() {
    $(document).off("wheel", wheely);
    $(document).off("keydown", hotkeys);
    $(document).off("touchstart mousedown", dragStart);
    $(document).off("touchend", dragEnd);
    $('.estimate').css({
        overflowY: 'auto',
        // paddingTop: '60px'
    });


    $(".estimate").scroll(function() {
        var element = $(this);
        if (element.scrollTop() + element.innerHeight() >= element[0].scrollHeight) {
            $('.estimate').css({
                overflowY: 'hidden',
                top: '0px'
            });
            $('.open-table').text('Раскрыть смету');

            const sectionSlides = document.querySelectorAll('section.slide:not(.benten)');

            for (let i = 0; i < sectionSlides.length; i++) {
                // sectionSlides[i].style.paddingTop = parseInt(getComputedStyle(sectionSlides[i]).paddingTop) + 60 + 'px';
                sectionSlides[i].style.top = '60px';
            }

            $(document).on("wheel", wheely);
            $(document).on("keydown", hotkeys);
            $(document).on("touchstart mousedown", dragStart);
            $(document).on("touchend mouseup", dragEnd);

            $('.options').slideUp(500);
            $('.smeta-item-head').removeClass('active');
            opened = 1;

            console.log('its working');
        }
    });

}

$('.open-table').on('click', openSm);
$(document).on('click', '.smeta-item-head', function(event) {
    var $input = $(this).find('input');
    var isExpanded = $(this).hasClass('active');

    if (!$(event.target).is('input')) {
        if (isExpanded) {
            // Действия при закрытии элемента
            $(this).removeClass('active');
            $(document).off("wheel", wheely);
            $(document).off("keydown", hotkeys);
            $(document).off("touchstart mousedown", dragStart);
            $(document).off("touchend mouseup", dragEnd);
            $('.estimate').css({
                overflowY: 'auto',
                top: '0px'
                // paddingTop: '60px'
            });

            $(".estimate").scroll(function() {
                var element = $(this);
                if (element.scrollTop() + element.innerHeight() >= element[0].scrollHeight) {
                    $('.estimate').css({
                        overflowY: 'hidden',
                        top: '0px'
                    });
                    $('.open-table').text('Раскрыть смету');

                    const sectionSlides = document.querySelectorAll('section.slide:not(.benten)');

                    for (let i = 0; i < sectionSlides.length; i++) {
                        // sectionSlides[i].style.paddingTop = parseInt(getComputedStyle(sectionSlides[i]).paddingTop) + 60 + 'px';
                        sectionSlides[i].style.top = '60px';
                    }

                    $('.smeta-item-head input').on('click', function(event) {
                        event.stopPropagation();
                        let end = $(this).val().length;
                        $(this).get(0).setSelectionRange(end, end);
                        $(this).focus();
                        var parentElement = event.target.closest('.smeta-item-head');

                        if (!parentElement.classList.contains('active')) {
                            parentElement.click();
                            let end = $(this).val().length;
                            $(this).get(0).setSelectionRange(end, end);
                            $(this).focus();
                            document.querySelector('.estimate').style.top = '0px';
                        }
                        document.querySelector('.estimate').style.top = '0px';
                        // for (let i = 0; i < sectionSlides.length; i++) {
                        //     sectionSlides[i].style.paddingTop = parseInt(getComputedStyle(sectionSlides[i]).paddingTop) - 60 + 'px';
                        // }
                    });



                    $(document).on("wheel", wheely);
                    $(document).on("keydown", hotkeys);
                    $(document).on("touchstart mousedown", dragStart);
                    $(document).on("touchend mouseup", dragEnd);

                    $('.options').slideUp(500);
                    $('.smeta-item-head').removeClass('active');
                    document.querySelector('.estimate').style.top = '0';
                    opened = 1;

                    console.log('its working');
                }
            });

        } else {
            // Действия при открытии элемента
            console.log("open")
            $(this).addClass('active');
            $($input).focus();
            document.querySelector('.estimate').style.top = '0';
        }
    }

    if (!isExpanded) {
        $(".estimate").off("scroll");
        $(document).on("wheel", wheely);
        $(document).on("keydown", hotkeys);
        $(document).on("touchstart mousedown", dragStart);
        $(document).on("touchend mouseup", dragEnd);
        document.querySelector('.estimate').style.top = '0px';
    }
});

// Добавьте обработчик события click на input, чтобы предотвратить его распространение
$(document).on('click', '.smeta-item-head input', function(event) {
    var parentElement = event.target.closest('.smeta-item-head');

    if (!parentElement.classList.contains('active')) {
        parentElement.click();
        let end = $(this).val().length;
        $(this).get(0).setSelectionRange(end, end);
        $(this).focus();
        document.querySelector('.estimate').style.top = '60px';
    }
});

$(document).on('click', '.open-table', function() {
    if ($(this).hasClass('active')) {
        $(this).removeClass('active');
        $(this).text('Раскрыть смету');
        $('.options').slideUp(500);
        $('.smeta-item-head').removeClass('active');
        document.querySelector('.smeta-item-head:first-child').click();
        document.querySelector('.smeta-item-head:first-child').click();
        document.querySelector('.estimate').style.top = '60px';

    } else {
        $(this).addClass('active');
        $(this).text('Закрыть смету');
        $('.smeta-item-head').addClass('active');
        $('.options').slideDown(500);
        document.querySelector('.estimate').style.top = '60px';
    }
    // opened = 1;
});
